import { Box, Button, styled, useTheme } from '@ltvco/refresh-lib/theme';

interface ToggleButtonProps {
  activeView: 'opinions' | 'similarCases';
  setActiveView: (view: 'opinions' | 'similarCases') => void;
  isLoadingSimilarCases: boolean;
  similarCasesData: {
    count: number;
    results: any[];
  };
}

export const ToggleOpinionsButton = ({
  activeView,
  setActiveView,
  isLoadingSimilarCases,
  similarCasesData,
}: ToggleButtonProps) => {
  const theme = useTheme();
  const StyledToggleContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.divider,
    borderRadius: theme.spacing(2.5),
    height: '40px',
    padding: `0 ${theme.spacing(0.5)}`,
  }));

  const ToggleButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    color: theme.palette.text.secondary,
    border: 'none',
    width: '50%',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  }));
  return (
    <StyledToggleContainer sx={{ mt: 2 }}>
      <ToggleButton
        variant={activeView === 'opinions' ? 'contained' : 'outlined'}
        size="small"
        onClick={() => setActiveView('opinions')}
        aria-pressed={activeView === 'opinions'}
        sx={
          activeView === 'opinions'
            ? {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                fontWeight: 600,
                boxShadow: '0px 2px 1px -1px #00000033',
                '&:hover': {
                  backgroundColor: theme.palette.background.paper,
                },
                '&:focus-visible': {
                  outline: `2px solid ${theme.palette.primary.main}`,
                  outlineOffset: '2px',
                },
              }
            : {
                fontWeight: 400,
              }
        }
      >
        Opinions
      </ToggleButton>
      <ToggleButton
        variant={activeView === 'similarCases' ? 'contained' : 'outlined'}
        size="small"
        onClick={() => setActiveView('similarCases')}
        aria-pressed={activeView === 'similarCases'}
        sx={
          activeView === 'similarCases'
            ? {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                fontWeight: 600,
                boxShadow: '0px 2px 1px -1px #00000033',
                '&:hover': {
                  backgroundColor: theme.palette.background.paper,
                },
                '&:focus-visible': {
                  outline: `2px solid ${theme.palette.primary.main}`,
                  outlineOffset: '2px',
                },
              }
            : {
                fontWeight: 400,
              }
        }
      >
        Similar Cases{' '}
        {isLoadingSimilarCases
          ? '(...)'
          : `(${similarCasesData?.count?.toLocaleString() || 0})`}
      </ToggleButton>
    </StyledToggleContainer>
  );
};
